import React, {ReactNode} from 'react';
import classnames from 'classnames';
import AppLabel from '../BaseLabel/BaseLabel';
import './appInputLabel.less';

interface AppendRequiredParams {
    label: ReactNode;
    required?: boolean;
    requiredCharacter: string;
}

function appendRequiredCharacterIfNecessary({label, required, requiredCharacter}: AppendRequiredParams): string {
    if (required && typeof label === 'string' && !label.includes(requiredCharacter)) {
        return ` ${requiredCharacter}`;
    }
    return '';
}

interface AppInputLabelProps {
    children: ReactNode;
    className?: string;
    disabled?: boolean;
    required?: boolean;
    error?: boolean;
    [key: string]: any;
}

const AppInputLabel = ({
    children, className, disabled, required, error, ...rest
}: AppInputLabelProps) => {
    const containerClassName = classnames('app-input-label', className, {
        disabled,
        required,
        error
    });
    const requiredCharacter = '*';

    return (
        <AppLabel
            className={containerClassName}
            {...rest}
        >
            {children}
            {appendRequiredCharacterIfNecessary({label: children, required, requiredCharacter})}
        </AppLabel>
    );
};
export default AppInputLabel;
